import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { Rfq, RfqsQuery as RfqsQuery } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.tradingBaseUrl };
}

class PublicRfqsApi {
  getRfqsAsync(query: RfqsQuery): Promise<Page<Rfq>> {
    return api.get<Page<Rfq>>(
      `/v1/quotation-requests`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getRfqAsync(id: string): Promise<Rfq>{
    return api.get<Rfq>(`/v1/quotation-requests/${id}`, getRequestConfig()).then(x => x.data);
  }
}

export default new PublicRfqsApi();